import axios from "axios";
import Cookies from "universal-cookie";

import parseCheckoutResponseFactory from "../utils/parse-checkout-response";
import checkoutFragment from "./checkout.fragment";
import { submitSentryError } from "../providers/error-boundary";
import { BACKEND_URL } from "../config";

const CREATE_CHECKOUT_QUERY = `
  mutation checkoutCreate($lineItems: [CheckoutLineItemInput!], $customAttributes: [AttributeInput!]) {
    checkoutCreate(input: { lineItems: $lineItems, customAttributes: $customAttributes } ) {
      checkout {
        ...cart
      }
      userErrors {
        message
        field
      }
    }
  }

  ${checkoutFragment}
`;

const addTrackingDataToAttributes = (keys, attributes) => {
	if (Array.isArray(keys)) {
		const cookies = new Cookies();
		keys.forEach((key) => {
			const value = cookies.get(key);
			if (value) {
				attributes.push({ key, value });
			}
		});
	}

	if (window && window.navigator && window.navigator.userAgent) {
		attributes.push({
			key: "user_agent",
			value: window.navigator.userAgent,
		});
	}
};

const createCheckout = (values, setCart, queryString) => {
	if (values.id.includes("__")) {
		values.id = values.id.split("__").pop();
	}

	const variables = {
		lineItems: [
			{
				variantId: values.id,
				quantity: values.quantity,
			},
		],
		customAttributes: [{}],
	};

	if (window && window.document.referrer) {
		variables.customAttributes.push({
			key: "Referrer",
			value: window.document.referrer,
		});
	}

	if (queryString) {
		const queryInfo = Object.entries(queryString).reduce(
			(acc, [key, value]) => {
				const nextEntry = `${key}: ${value}\n`;
				return acc + nextEntry;
			},
			""
		);

		Object.entries(queryString).forEach(([key, value]) => {
			const attribute = { key, value };
			variables.customAttributes.push(attribute);
		});
	}

	// Cookies
	addTrackingDataToAttributes(
		["_fbp", "_fbc", "_ga", "_gid"],
		variables.customAttributes
	);

	// Convert all key and value pairs for customAttributes to
	// match graphql type `String!`
	if (Array.isArray(variables.customAttributes)) {
		variables.customAttributes = variables.customAttributes
			.map(({ key, value }) => {
				if (!key || value === undefined) {
					return null;
				}

				return {
					key: String(key),
					value: String(value),
				};
			})
			.filter((item) => item);
	}

	const payload = {
		query: CREATE_CHECKOUT_QUERY,
		variables,
	};

	let headers = {
		"Content-Type": "application/json",
	};

	const parseCheckoutResponse =
		parseCheckoutResponseFactory("checkoutCreate");

	return axios
		.post(BACKEND_URL, payload, { headers })
		.then(parseCheckoutResponse)
		.then((result) => {
			setCart(result);
			return result;
		})
		.catch((error) =>
			submitSentryError(error, {
				tag: { api: "Shopify", action: "createCheckout" },
			})
		);
};

export default createCheckout;
